export const SERVICES_ON_DELETE_REQUESTED = 'SERVICES_ON_DELETE_REQUESTED';
export const SERVICES_ON_DELETE_SUCCEEDED = 'SERVICES_ON_DELETE_SUCCEEDED';
export const SERVICES_ON_DELETE_FAILED = 'SERVICES_ON_DELETE_FAILED';

export const SERVICES_ON_GET_ALL_REQUESTED = 'SERVICES_ON_GET_ALL_REQUESTED';
export const SERVICES_ON_GET_ALL_SUCCEEDED = 'SERVICES_ON_GET_ALL_SUCCEEDED';
export const SERVICES_ON_GET_ALL_FAILED = 'SERVICES_ON_GET_ALL_FAILED';

export const SERVICES_ON_GET_ONE_REQUESTED = 'SERVICES_ON_GET_ONE_REQUESTED';
export const SERVICES_ON_GET_ONE_SUCCEEDED = 'SERVICES_ON_GET_ONE_SUCCEEDED';
export const SERVICES_ON_GET_ONE_FAILED = 'SERVICES_ON_GET_ONE_FAILED';

export const SERVICES_ON_SAVE_REQUESTED = 'SERVICES_ON_SAVE_REQUESTED';
export const SERVICES_ON_SAVE_SUCCEEDED = 'SERVICES_ON_SAVE_SUCCEEDED';
export const SERVICES_ON_SAVE_FAILED = 'SERVICES_ON_SAVE_FAILED';
